import type {
  WhatsAppMappingType,
  WhatsAppMediaType,
} from "src/services/WhatsAppCampaignAPI";
import type {
  WhatsAppButtonType,
  WhatsAppCampaignStepKey,
  WhatsAppTemplateStatusFilter,
} from "./WhatsAppCampaignTypes";

export const WHATSAPP_EDITOR_KEY = "campaignFlow.whatsappEditor";

export const WHATSAPP_CAMPAIGN_STEPS: { key: WhatsAppCampaignStepKey; titleKey: string }[] = [
  { key: "chooseTemplate", titleKey: `${WHATSAPP_EDITOR_KEY}.steps.chooseTemplate` },
  { key: "editor", titleKey: `${WHATSAPP_EDITOR_KEY}.steps.editor` },
];

export const TEMPLATE_STATUS_FILTERS: WhatsAppTemplateStatusFilter[] = [
  "all",
  "approved",
  "pending",
  "rejected",
  "draft",
  "unavailable",
];

export const VARIABLE_MAPPING_TYPES: WhatsAppMappingType[] = ["column", "static", "date"];

export const TEMPLATE_PLACEHOLDER_PATTERN = /\{\{(\d+)\}\}/;

export const MEDIA_RULES: Record<WhatsAppMediaType, { accept: string[]; maxSizeMb: number }> = {
  image: { accept: ["image/jpeg", "image/png"], maxSizeMb: 5 },
  video: { accept: ["video/mp4", "video/3gpp"], maxSizeMb: 16 },
  document: { accept: ["application/pdf"], maxSizeMb: 100 },
};

export const BYTES_PER_MB = 1024 * 1024;

export const TEMPLATES_PAGE_SIZE = 6;
export const PREVIEW_DEBOUNCE_MS = 400;

export const MESSAGE_TIME_FORMAT = "h:mm A";
export const DATETIME_PARAMETER_FORMAT = "dddd, MMMM D [at] h:mm A";
export const DATETIME_VALUE_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const NO_LIST_NAMES: string[] = [];

export const TEMPLATE_LANGUAGES = [
  { value: "en", label: "English" },
  { value: "ar", label: "Arabic" },
];

export const DEFAULT_SAMPLE_COLUMNS = [
  "First_Name",
  "Last_Name",
  "Full_Name",
  "Email",
  "Order_ID",
  "Discount_Value",
  "Amount",
  "Coupon_Code",
  "Date",
];

export const SAMPLE_VALUES_BY_KEYWORD: [string, string][] = [
  ["firstname", "Sara"],
  ["lastname", "Khan"],
  ["fullname", "Sara Khan"],
  ["name", "Sara"],
  ["email", "sara@example.com"],
  ["discount", "20"],
  ["percent", "20"],
  ["amount", "100"],
  ["price", "100"],
  ["total", "100"],
  ["order", "12345"],
  ["coupon", "SPRING20"],
  ["code", "SPRING20"],
  ["date", "01 Jan"],
];

export const EMOJIS = [
  "😀", "😁", "😂", "😊", "😍", "😎", "🤩", "🥳", "😉", "🙏",
  "👍", "👏", "🙌", "💪", "🔥", "✨", "🎉", "🎁", "❤️", "💙",
  "⭐", "🌟", "💯", "✅", "🛍️", "🛒", "💳", "🏷️", "📦", "🚚",
  "⏰", "📅", "📍", "📞", "💬", "🔔", "🌙", "☀️", "🌸", "🎊",
];

export const TEMPLATE_FORM_LIMITS = {
  name: 512,
  header: 60,
  body: 1024,
  footer: 60,
  buttonText: 40,
  offerCode: 20,
  maxButtons: 3,
};

export const TEMPLATE_NAME_PATTERN = /^[a-z0-9_]+$/;
export const PHONE_NUMBER_PATTERN = /^\d{4,15}$/;

export const BUTTON_TYPES: WhatsAppButtonType[] = [
  "visit_website",
  "call_whatsapp",
  "call_phone",
  "copy_code",
];

export const BUTTON_DEFAULT_TEXT: Record<WhatsAppButtonType, string> = {
  visit_website: "",
  call_whatsapp: "Call on WhatsApp",
  call_phone: "Call Phone Number",
  copy_code: "Copy offer code",
};

export const CALL_ACTIVE_DAYS = [7, 14, 30];
export const COUNTRY_CODES = ["+1", "+44", "+91", "+92", "+971", "+966"];
